import dynamic from 'next/dynamic';

export interface ILightboxImage {
  src:string,
  alt:string,
  title:string,
}
export interface ILightboxProps {
  onClose: ()=>void,
  index: number,
  images: Array<ILightboxImage>;
}

const DynamicComponent = dynamic(() => import('./Lightbox'), { loading: () => null });

export const Lightbox = (props: ILightboxProps) => (
  <DynamicComponent {...props} />
);
